import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const BannerRoot = styled.div`
  padding: 0.75rem;
  border-radius: 6px;
  color: ${color("text-medium")};
  background-color: ${color("bg-light")};
`;
